import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageComponent } from '../../../../../services/website.service';

/**
 * Ruw HTML/JS/CSS-blok. De redacteur plakt hier zelf HTML in, inclusief
 * `<style>`- en `<script>`-blokken. De preview draait in een iframe
 * (srcdoc), zodat scripts wel worden uitgevoerd en de cockpit-styling
 * niet gaat lekken in de widget. Voor de live-site rendert
 * `HtmlBlockSection` in dwt-website dezelfde HTML met script-executie
 * na mount.
 */
@Component({
  selector: 'app-html-block-component',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './html-block-component.component.html',
  styleUrls: ['./html-block-component.component.scss'],
})
export class HtmlBlockComponentComponent {
  @Input() component!: PageComponent;
  @Input() mode: 'preview' | 'edit' = 'preview';
  @Input() isSelected = false;
  @Output() contentChange = new EventEmitter<string>();
  @Output() styleChange = new EventEmitter<void>();

  getHtml(): string {
    return (this.component.data['html'] as string) || '';
  }

  onHtmlChange(value: string): void {
    this.component.data['html'] = value;
    this.contentChange.emit(value);
  }

  getPaddingY(): number {
    const v = this.component.data['paddingY'];
    return typeof v === 'number' ? v : 0;
  }

  setPaddingY(value: number): void {
    this.component.data['paddingY'] = Number(value) || 0;
    this.styleChange.emit();
  }

  getWrapperClass(): string {
    return (this.component.data['wrapperClass'] as string) || '';
  }

  setWrapperClass(value: string): void {
    this.component.data['wrapperClass'] = value;
    this.styleChange.emit();
  }

  /** srcdoc voor de preview-iframe. Voegt geen wrappers toe: de HTML
   *  van de redacteur is de hele body. */
  getIframeSrcdoc(): string {
    const html = this.getHtml();
    return `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>html,body{margin:0;padding:0;background:#fff;color:#111;font-family:system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;}</style></head><body>${html}</body></html>`;
  }

  isEmpty(): boolean {
    return this.getHtml().trim().length === 0;
  }
}
